import { Box, Paper } from '@mui/material';
import React from 'react';

interface MessageContainerProps {
  isUser: boolean;
  children: React.ReactNode;
}

export const MessageContainer: React.FC<MessageContainerProps> = ({ isUser, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isUser ? 'flex-end' : 'flex-start',
        mb: 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: isUser ? 'flex-end' : 'flex-start',
          width: '100%',
        }}
      >
        <Paper
          elevation={1}
          sx={{
            p: 2,
            maxWidth: '80%',
            backgroundColor: isUser ? 'rgba(225, 158, 25, 0.1)' : 'rgba(0, 48, 100, 0.05)',
            borderRadius: isUser ? '8px 8px 0 8px' : '8px 8px 8px 0',
            borderLeft: isUser ? '3px solid #E19E19' : '3px solid #003064',
            fontFamily: '"Roboto", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
          }}
        >
          {children}
        </Paper>
      </Box>
    </Box>
  );
};